import {useContext} from 'react';
import CompanyContext from './CompanyContext';
import {ContextValue} from './types';

export default function useCompany(): ContextValue {
  return useContext(CompanyContext);
}
